import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AccessRights from "../../../../configs/constants/accessRights";
import { getAnalyticsOverview, getAnalyticsSla } from "../../redux/action";
import AnalyticsPage from "./analytics.page";

export default function AnalyticsContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const canView = useSelector((state) => state.session.accessRights.includes(AccessRights.SUPPORT_ANALYTICS_VIEW));

  useEffect(() => {
    if (!canView) {
      navigate("/admin");
    }
  }, [canView]);

  const overview = useSelector((state) => state.support.analyticsOverview);
  const slaData = useSelector((state) => state.support.analyticsSla);

  useEffect(() => {
    dispatch(getAnalyticsOverview({}));
    dispatch(getAnalyticsSla({}));
  }, [dispatch]);

  return <AnalyticsPage overview={overview} slaData={slaData} />;
}
